import React, { Suspense, ReactNode } from "react";
import { MatxLoading } from "app/components";

interface MatxSuspenseProps {
    children: ReactNode;
}

const MatxSuspense = ({ children }: MatxSuspenseProps) => {
    return <Suspense fallback={<MatxLoading />}>{children}</Suspense>;
};

export default MatxSuspense;
